export default __webpack_public_path__ + "static/media/prev-GNSS-Antenna-3.0f87a727.png";